var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#21B55A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.0013,
    cy: 39.1952,
    r: 23.7303,
    fill: "#21B55A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.0009,
    cy: 39.1949,
    r: 27.1642,
    fill: "#21B55A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0266 26.8799C34.6133 26.8799 31.0266 30.4665 31.0266 34.8799V38.7332C31.0266 39.5466 30.6799 40.7865 30.2666 41.4799L28.7333 44.0266C27.7866 45.5999 28.4399 47.3466 30.1733 47.9332C35.9199 49.8532 42.1199 49.8532 47.8666 47.9332C49.4799 47.3999 50.1866 45.4932 49.3066 44.0266L47.7733 41.4799C47.3733 40.7865 47.0266 39.5466 47.0266 38.7332V34.8799C47.0266 30.4799 43.4266 26.8799 39.0266 26.8799Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4933 27.2664C41.0799 27.1464 40.6533 27.0531 40.2133 26.9998C38.9333 26.8398 37.7066 26.9331 36.5599 27.2664C36.9466 26.2798 37.9066 25.5864 39.0266 25.5864C40.1466 25.5864 41.1066 26.2798 41.4933 27.2664Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0266 48.4136C43.0266 50.6136 41.2266 52.4136 39.0266 52.4136C37.9333 52.4136 36.9199 51.9602 36.1999 51.2402C35.4799 50.5202 35.0266 49.5069 35.0266 48.4136",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.7681635f74fc10a33551d19fe1eb89ef.svg";
export { ForwardRef as ReactComponent };